import React from "react";
import "./App.css";
import DriverDashboard from "./components/DriverDashboard";
import LoginPage from "./components/LoginPage";
import RiderDashboard from "./components/RiderDashboard";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

const AppContent: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();

  // console.log("AppContent rendered:", { isAuthenticated, user, isLoading });

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <LoginPage />;
  }

  // If the authenticated user is an admin, show an access-denied screen
  if (user.role === "admin") {
    return <AdminAccessDenied />;
  }

  return user.role === "rider" ? <RiderDashboard /> : <DriverDashboard />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="App">
        <AppContent />
      </div>
    </AuthProvider>
  );
};

export default App;

// Simple access denied view for admin users who landed on the rider/driver app
const AdminAccessDenied: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", padding: 20 }}>
      <div style={{ maxWidth: 560, width: "100%", background: "white", borderRadius: 8, boxShadow: "0 6px 18px rgba(0,0,0,0.08)", padding: 24, textAlign: "center" }}>
        <h2 style={{ marginTop: 0 }}>Access Denied</h2>
        <p style={{ color: "#444" }}>
          Your account is an administrator account and cannot access this rider/driver application.
        </p>
        <p style={{ color: "#444" }}>
          Please sign in via the Admin Dashboard to manage the site.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 18 }}>
          <a
            href="https://admin.cabservice.iiitd.edu.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "var(--primary-teal, #00897b)",
              color: "white",
              padding: "8px 14px",
              borderRadius: 6,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Open Admin Dashboard
          </a>
          <button
            onClick={() => logout()}
            style={{
              background: "#efefef",
              color: "#222",
              padding: "8px 14px",
              borderRadius: 6,
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};
